export default "__VITE_ASSET__CcDbayrD__"